export default "/images/d68cfe7c2d996c3cf0b01fae0ad104cc.png";